/* unplugin-vue-components disabled */import script from "./merchant_day.vue?vue&type=script&setup=true&lang=js"
export * from "./merchant_day.vue?vue&type=script&setup=true&lang=js"

import "./merchant_day.vue?vue&type=style&index=0&id=30b4292f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b4292f"]])

export default __exports__